import axios from 'axios';
import {tApi} from 'tplus-api';
const QS = require('qs');

export default class LoginApi{
  
  static async getSysInfoForGZQ(){
    const method = 'chanjet.MB.TxBusCommon.GetSysInfoForGZQ';
    const resp = await tApi({},method,false);
    return resp;
  }

  static async getOrderFunction(param){
    const method = 'chanjet.MB.MBPortal.GetPortalByAppid';
    const resp = await tApi(param,method,false);
    return resp;
  }

  static async getAccountInfo(param){
    const method = 'chanjet.SM.AccountOption.GetAccountInfoValues';
    const resp = await tApi(param,method,false);
    return resp;
  }

  static async getVoucherWorkFlow(param){
    const method = 'chanjet.MB.TxBusCommon.IsVoucherNeedWorkFlow';
    const resp = await tApi(param,method,false);
    return resp;
  }

  static async GetWhetherEnableSaleSingleFullGift(){
    const method = 'chanjet.PR.SalesPromotion.IsExistSalesPromotion';
    const resp = await tApi({},method,false);
    return resp;
  }

  static async GetSignInOption(){
    const method = 'chanjet.CM.OptionMB.GetSignInOption';
    const resp = await tApi({},method,false);
    return resp;
  }

  static async getSaleDeliveryInvoiceType(){
    const param = {enumName:'SaleDeliveryInvoiceType',noDel:true}
    const method = 'chanjet.EAP.Enum.getEnumObjByName';
    const resp = await tApi(param,method,false);
    return resp;
  }

}
